import httpClient from "../Core/http";

class ServiceAgreementsAPi {
  getCustomerServiceAgreements(params: any, signal: any): Promise<any> {
    let url = "serviceAgreements/customer";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
        //  console.log("sa", response);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const ServiceAgreementsApi = new ServiceAgreementsAPi();
